import React from 'react';

 const GPS: React.FC = () => {
 	return (
 		<iframe src={"https://master.d1u75ei0o48cf3.amplifyapp.com/"} allow="geolocation" width="100%" height="87%" frameBorder="0" />
 	);
 };

 export default GPS;
